import { RETAILERS } from './urls';

export const getRetailerInfo = () => fetch(RETAILERS);
